import { useEffect, useState } from "react";
import { DataTable } from "@/components/custom/DataTable";
import PageLayout from "@/components/custom/PageLayout";
import SearchFilter from "@/components/custom/SearchFilter";
import TopBar from "@/components/custom/TopBar";
import { useTheme } from "@/themeConfigs/ThemeContext";
import {
  HubChargerStatusFullyCharged,
  useFullyChargedColumns,
} from "./columns";
import DashboardService from "@/services/api/DashboardService"; // Make sure to import your service
import { BottomNav } from "@/components/custom/BottomNav";
import { useHubDetails } from "@/redux/hooks/useSupervisorDetails";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const FullyCharged = () => {
  const { theme } = useTheme();
  const columns = useFullyChargedColumns();
  const [data, setData] = useState<HubChargerStatusFullyCharged[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const hubDetails = useHubDetails();

  const fullChargedCars = useSelector(
    (state: RootState) => state.chargerStatus.charger_status?.full_charged_cars
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response =
          await DashboardService.getChargerStatusDashboardDetails(
            hubDetails?.name as string,
            "full"
          );
        if (response.success) {
          const transformedData = response.data.car_details.map((item) => ({
            charger_number: item.charger_code,
            vehicle_number: item.vrn,
            start_soc: `${item.start_soc}%`,
            end_soc: `${item.end_soc}%`,
          }));
          setData(transformedData);
        }
      } catch (error) {
        console.error("Failed to fetch data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <PageLayout>
        <TopBar
          color={theme.colors["supervisor-red"]}
          text="Vehicles @100%"
          number={fullChargedCars ? fullChargedCars.toString() : "0"}
        />
        {loading ? (
          <div>Loading...</div>
        ) : (
          <DataTable
            columns={columns}
            data={data}
            headerColor="bg-primary text-primary-foreground"
            alignment="center"
            rowsPerPage={10}
          />
        )}
      </PageLayout>
      <BottomNav active={1} />
    </>
  );
};

export default FullyCharged;
